import FAQStyles from "./FAQ.module.css";

const FaqDesktop = FAQStyles.checklistDesktop; //desktop

const FAQData = [
  {
    id: 1,
    question:
      "1. Do you offer full-time or part-time biologic/ access Coordinators?",
    answer: "We offer both.  It depends on the needs of the office.",
  },

  {
    id: 2,
    question: "2. Why would one be called  an access coordinator? ",
    answer:
      "Access Coordinators work beyond the scope of biologics.  We assist in approval of specialty medications including creams, systemics and infusions. ",
  },

  {
    id: 3,
    question: "3.How long does it typically take to get an approval? ",
    answer:
      "If we have all of the necessary paperwork filled out and signed,  it can take 48-72 hours for complete processing. ",
  },

  {
    id: 4,
    question: "4.What specialties do you collaborate with?",
    answer:
      "We are equipped to handle Asthma Allergy,  Dermatology,  Rheumatology, and Gastroenterology.",
  },

  {
    id: 5,
    question: "5.What happens when a medication is not on the formulary? ",
    answer:
      "We will never change a prescription unless advised by the HCP. We work with hub services for bridge programs and patient assistance programs when needed.",
  },

  {
    id: 6,
    question: "6.Do you only assist physicians in Texas?",
    answer: "No, we are national, with advisors in many states.",
  },

  {
    id: 7,
    question: "7.Do you use a particular pharmacy? ",
    answer:
      "We typically use what has been mandated by the patient's insurance plan, unless deemed otherwise",
  },
];

export default FAQData;
